/*
 * @Author: emilwang <emilwang@lexin>
 * @Date: 2021-05-26 14:59:06
 * @LastEditTime: 2024-01-08 18:59:15
 * @LastEditors: ryanzhao1
 * @Description: 
 * @FilePath: \plc_web\src\pc\views\home\pages\rule_list\rule_list.js
 * ©lexin ec-frd
 */
import M_REQUEST from '~request@1.0'
import layout from '@pc/views/home/components/layout/index.vue'
import list from '@pc/views/home/components/list/index.vue'
import M_URL from '~url@1.0'

import { dataReport } from '@pc/components/libs/util'

const G_SENCE = 'officialPlatformAgreementRules'
const G_REQUEST = new M_REQUEST({ gatewayType: 'platform' })
const G_QUERY = M_URL.getUrlParam() || {}
const G_ACTIVE_KEY = G_QUERY.activeKey || 'platformAgreementForLoan' //当前选中列表key,默认分期乐借钱平台协议

export default {
	data () {
		return {
			keyNameList: [], // key:name形式的数组
			ruleList: [], // 规则列表
			activeKey: this.$route.query.activeKey || G_ACTIVE_KEY, // 当前选中列表序号
			scene: this.$route.query.scene || ''
		}
	},

	components: {
		layout,
		list,
	},

	methods: {
		// 逻辑入口
		init () {

			this.queryCategoryList()
		
		},

		// 查询协议分类列表
		queryCategoryList() {
			dataReport({
				eventPosName: 'rule分类查询',
				hottag: 'CATEGORY_VIEW'
			})

			G_REQUEST.ajax({
				url: '/route0014/platform/basic/agreementManageService/getCategoryList.json',
				data: {
					scene: G_SENCE,
				}
			}).then(res => {
				if (+res.retcode === 0) {
					let result = res.result_rows || {}
					this.keyNameList = result.list?.map?.((item) => {
						const { categoryName, categoryKey } = item
						return {
							name: categoryName,
							key: categoryKey,
						}
					})
					this.queryRuleList(this.activeKey)

					dataReport({
                        eventPosName: 'rule分类查询成功',
                        hottag: 'CATEGORY_VIEW_SUCCESS'
                    })
				} else {
					dataReport({
                        eventPosName: 'rule分类查询失败',
                        hottag: 'CATEGORY_VIEW_ERR'
                    }, res)
				}

			}).catch(err => {
				this.$message.error(err)

				dataReport({
                    eventPosName: 'rule分类查询失败',
                    hottag: 'CATEGORY_VIEW_ERR'
                }, err)
			})

		},

		// 查询协议列表
		queryRuleList (key) {
			const data = {
				scene: G_SENCE,
				category: key || this.keyNameList?.[0]?.key
			}

			dataReport({
                eventPosName: 'rule列表查询',
                hottag: 'RULE_VIEW'
            })

			G_REQUEST.ajax({
				url: '/route0014/platform/basic/agreementManageService/getAgreementList.json',
				data
			}).then(res => {

				if (+res.retcode === 0) {
					let result = res.result_rows || {}
					this.ruleList = result.list || []

					dataReport({
                        eventPosName: 'rule列表查询成功',
                        hottag: 'RULE_VIEW_SUCCESS'
                    })
				} else {
					dataReport({
                        eventPosName: 'rule列表查询失败',
                        hottag: 'RULE_VIEW_ERR'
                    }, { ...res, ...data })
				}

			}).catch(err =>{
				this.$message.error(err)

				dataReport({
                    eventPosName: 'rule列表查询失败',
                    hottag: 'RULE_VIEW_ERR'
                }, { ...err, ...data })
			})

		},
		
		// 切换导航
		switchNav (key) {
			// 查询中 or 当前导航已选中 禁止切换
			if (key === this.activeKey) {
				return
			}
			// 更新导航选中标志
			this.activeKey = key
			// 清空列表
			this.ruleList = []
			this.$router.replace({ name: 'rule_list', query: { activeKey: key } })
			// 更新协议列表
			this.queryRuleList(key)
			
		},

		// 跳转到详情页
		linkToDetail (data) {
			dataReport({
                eventPosName: '查看按钮点击',
                hottag: 'RULE_LIST_VIEW'
            }, data)

			const { extension } = data || {}
			const { url } = extension || {}
			url ?  window.document.location.href = url : ''
		},

		// 下载pdf
		downloadPdf (data) {
			dataReport({
                eventPosName: '下载按钮点击',
                hottag: 'RULE_LIST_DPWNLOAD'
            }, data)

			const { extension } = data || {}
			const { downloadUrl } = extension || {}

			downloadUrl ?  window.document.location.href = downloadUrl : ''
		},

		// 跳转到历史页
		linkToHistory (data) {
			dataReport({
                eventPosName: '历史协议按钮点击',
                hottag: 'RULE_LIST_HISTORY'
            }, data)

			const { templateCode } = data || {}

			this.$router.push({
				path: '/rule_history',
				query: {templateCode}
			})
		},
	},

    mounted () {
        this.init()
    }
}